export default __webpack_public_path__ + "static/media/1855.bd7333db.png";